import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { InventoryPartListParams } from '../../../types/inventory/inventoryTypes'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

let prevController: AbortController | null = null

const loadInventoryPartList =
    (params: InventoryPartListParams) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<boolean> => {
        if (prevController) {
            prevController.abort()
        }

        const controller = new AbortController()
        const { signal } = controller
        prevController = controller

        const { userData } = getState()

        dispatch({ type: storeDispatchTypes.setInventoryLoading, value: true })

        try {
            const response = await apiInstance.post(
                '/inventory/getInventoryPartList',
                {
                    userId: userData.smsAuth.userId,
                    params: {
                        ...params,
                        includeFacets: false,
                    },
                },
                {
                    headers: {
                        Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
                    },
                    signal,
                },
            )

            if (response?.data) {
                dispatch({
                    type: storeDispatchTypes.setInventoryPartList,
                    value: response.data,
                })
            }

            return true
        } catch (e) {
            if (signal.aborted) {
                return false
            }

            console.error('load inventory parts failed', e)
            dispatch({
                type: storeDispatchTypes.setInventoryPartList,
                value: {
                    data: [],
                    dataCount: 0,
                    total: 0,
                    facets: {
                        warehouses: [],
                        rows: [],
                        shelves: [],
                        places: [],
                    },
                },
            })

            return false
        } finally {
            if (!signal.aborted) {
                dispatch({
                    type: storeDispatchTypes.setInventoryLoading,
                    value: false,
                })
            }
        }
    }

export default loadInventoryPartList
